import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from 'components/qstrap'

class DropdownFilter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
    }

    this.handleToggle = this.handleToggle.bind(this)
  }

  handleToggle() {
    this.setState(prevState => ({
      open: !prevState.open,
    }))
  }

  render() {
    const {
      selectedOption,
      options,
      onChange,
      labelText,
      optionText,
    } = this.props

    const label = labelText || intl.get('molecules.dropdownFilter.filter')
    const defaultOption = optionText || intl.get('molecules.dropdownFilter.all')

    return (
      <Dropdown isOpen={this.state.open} toggle={this.handleToggle} className="dropdown-filter">
        <DropdownToggle caret>
          {
            selectedOption ?
              options.find(option => option.id === selectedOption).name
              : label
          }
        </DropdownToggle>
        <DropdownMenu>
          <div
            onClick={() => {
              onChange({ id: undefined, slug: undefined })
              this.handleToggle()
            }}
            className="dropdown-filter-item"
          >
            {defaultOption}
            <div className="dropdown-filter-badge">
              {options.map(opt => opt.childCount).reduce((x, y) => x + y, 0)}
            </div>
          </div>
          {
            options.map(option => (
              <div
                key={option.id}
                onClick={() => {
                  onChange(option)
                  this.handleToggle()
                }}
                className="dropdown-filter-item"
              >
                {option.name}
                <div className="dropdown-filter-badge">{option.childCount}</div>
              </div>
            ))
          }
        </DropdownMenu>
      </Dropdown>
    )
  }
}

DropdownFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selectedOption: PropTypes.string,
  labelText: PropTypes.string,
  optionText: PropTypes.string,
}

export default DropdownFilter
